// extracted by mini-css-extract-plugin
module.exports = {"clientName":"ClientName_clientName__30yPL","icon":"ClientName_icon__3R3p7"};